var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 40 40" }, props),
    React.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M20.3 6.3c-7.7 0-14 6.3-14 14s6.3 14 14 14 14-6.3 14-14c0-7.8-6.3-14-14-14zm2 10.3c1.9 0 3.5 1.2 3.5 3.6 0 2.4-2 5-3.5 5s-3.5-2.7-3.5-5c0-2.5 1.5-3.6 3.5-3.6zm-8.1-1.7c1.2 0 2.2.8 2.2 2.2 0 1.5-1.2 3.2-2.2 3.2-.9 0-2.2-1.7-2.2-3.2 0-1.5 1-2.2 2.2-2.2zM10.9 22c0-.9.8-1.6 2-1.8.4.4.9.8 1.3.8s.9-.3 1.3-.8c1.2.2 2 .9 2 1.8 0 1.3-6.6 1.3-6.6 0zm6.1 5.8c0-2 1.3-2.4 3.2-2.8.6.7 1.4 1.2 2.1 1.2.7 0 1.4-.6 2.1-1.3 1.9.4 3.2.9 3.2 2.9s-10.6 2-10.6 0z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/products/Users.svg